import { ValidationErrors } from '@angular/forms';
import { createAction, props } from '@ngrx/store';
import dayjs from 'dayjs';

export const SetTimePickerValues = createAction(
  '[TimePicker] Set Values',
  props<{
    start: dayjs.Dayjs | null
    end: dayjs.Dayjs | null
    availabilityPlanId?: number | null
    recurrenceFreq?: string | null
    quantity?: number | null
    preparationMinutes?: number
    followUpMinutes?: number
  }>()
)

export const SetStartDate = createAction(
  '[TimePicker] Set Start Date',
  props<{ startDate: dayjs.Dayjs }>()
)

export const SetEndDate = createAction(
  '[TimePicker] Set End Date',
  props<{ endDate: dayjs.Dayjs }>()
)

export const SetAvailabilityPlanId = createAction(
  '[TimePicker] Set Availability Plan Id',
  props<{ availabilityPlanId?: number }>()
)

export const SetQuantity = createAction(
  '[TimePicker] Set Quantity',
  props<{ quantity: number }>()
)

export const SetPreparationMinutes = createAction(
  '[TimePicker] Set Preparation Minutes',
  props<{ minutes: number }>()
)

export const SetFollowUpMinutes = createAction(
  '[TimePicker] Set Follow-Up Minutes',
  props<{ minutes: number }>()
)

export const SetRecurrenceFreq = createAction(
  '[TimePicker] Set Recurrence Freq',
  props<{ recurrenceFreq: string | null }>()
)

export const SetTimePickerErrors = createAction(
  '[TimePicker] Set TimePicker Errors',
  props<{ errors: ValidationErrors | null }>()
)
